import { useQuery } from "react-query";
import { getMostArticle } from "../api.zendesk.service";
import { readSystemState } from "../maintenance.service";

const API_ZENDESK_QUERY_KEY = {
  GET_SYSTEM_STATE: "GET_SYSTEM_STATE",
} as const;

export const useGetSytemState = () =>
  useQuery([API_ZENDESK_QUERY_KEY.GET_SYSTEM_STATE], () => readSystemState(), {
    enabled: true,
  });
